import type { ReactNode } from "react";
import Popover from "@mui/material/Popover";
import { PButton } from "../ui/PButton";

// PRIMENG `p-confirmPopup` AS THE PILLARS THEMES AND `_overrides.scss` DRAW IT: NO ARROW,
// 1PX `rgba(0,0,0,.2)` BORDER (`#3f4b5b` DARK), 4PX RADIUS, 1.25REM CONTENT, THEN A
// RIGHT-ALIGNED 0.5REM 1.25REM FOOTER OF TWO SMALL BUTTONS 0.5REM APART - REJECT FIRST
// (`p-button-outlined p-button-sm text-gray-500`), ACCEPT SECOND (`p-button-sm`, PLUS
// `bg-danger` FOR A DESTRUCTIVE ONE). AN OUTSIDE CLICK OR ESCAPE HIDES IT WITHOUT
// ACCEPTING OR REJECTING, AS PRIMENG DOES.
export function ConfirmPopup(props: {
  anchorEl: HTMLElement | null;
  onHide: () => void;
  acceptLabel: string;
  rejectLabel: string;
  onAccept: () => void;
  onReject: () => void;
  danger?: boolean;
  ariaLabel: string;
  children: ReactNode;
}) {
  const { anchorEl, onHide, acceptLabel, rejectLabel, onAccept, onReject, danger = false, ariaLabel, children } = props;
  return (
    <Popover
      open={anchorEl !== null}
      anchorEl={anchorEl}
      onClose={onHide}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      slotProps={{
        paper: {
          "aria-label": ariaLabel,
          className: "pillars-confirm-popup",
          sx: { mt: "0.75rem", borderRadius: "4px", minWidth: 240 },
        },
      }}
    >
      <div style={{ padding: "1.25rem" }}>{children}</div>
      <div style={{ textAlign: "right", padding: "0.5rem 1.25rem" }}>
        <PButton label={rejectLabel} size="sm" variant="outlined" className="text-gray-500" onClick={onReject} sx={{ mr: "0.5rem" }} />
        <PButton
          label={acceptLabel}
          size="sm"
          onClick={onAccept}
          sx={danger ? { backgroundColor: "var(--red-500)", borderColor: "var(--red-500)" } : undefined}
        />
      </div>
    </Popover>
  );
}
